import React, {FC} from 'react'
import styled from 'styled-components';


const LinkContent = styled.a<LinkProps>`
    color: ${(props) => (props.white ? "#fff" : "#000")};

    &:hover{
      color: #1196DD;
    }
`
interface LinkProps{
    href?: any
    style?: any
    white?: boolean
}

const LinkComponent: FC<LinkProps> = ({href, style, children, white }) => {
  return (
    <LinkContent href={href} style={style} white={white}>
        {children}
    </LinkContent>
  )
}

export default LinkComponent;